import { render, staticRenderFns } from "./ListBookableRoomCard.vue?vue&type=template&id=6bbfb822&scoped=true&"
import script from "./ListBookableRoomCard.vue?vue&type=script&lang=js&"
export * from "./ListBookableRoomCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbfb822",
  null
  
)

export default component.exports